angular.module('elogbooksServices').service('confirmationModalNotes', ['$uibModal', '$filter', function ($uibModal, $filter) {
    return {
        open: function (config) {
            return $uibModal.open({
                templateUrl: '/modules/common/modals/confirmation-notes/confirmation-notes.html',
                controller: 'ConfirmationModalNotesController',
                controllerAs: 'vm',
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            titleMessage: 'ARE_YOU_SURE_HEADER',
                            bodyMessage: 'ARE_YOU_SURE',
                            primaryText: 'YES',
                            primaryClass: 'btn-danger',
                            secondaryText: 'NO',
                            secondaryClass: 'btn-default'
                        };

                        return angular.extend({}, defaultConfig, config);
                    }
                }
            });
        }
    };
}]);
